export default "__VITE_ASSET__DLB9BKX4__"